import React, { useEffect, useState, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './SubscriptionResult.css';

const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const { fetchUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sessionId = searchParams.get('session_id');

  const verifyAndActivate = useCallback(async () => {
    if (!sessionId) {
      setLoading(false);
      return;
    }

    try {
      // Verify the session and activate subscription
      await api.post('/subscription/verify-session', { sessionId });
      // Refresh user data
      await fetchUser();
    } catch (err) {
      console.error('Verification error:', err);
      setError('There was an issue activating your subscription. Please contact support.');
    } finally {
      setLoading(false);
    }
  }, [sessionId, fetchUser]);

  useEffect(() => {
    verifyAndActivate();
  }, [verifyAndActivate]);

  return (
    <div className="subscription-result">
      <div className="container">
        <div className="result-card success">
          <div className="result-icon">🎉</div>
          <h1>Welcome to Premium!</h1>
          <p className="result-message">
            Your subscription has been activated successfully. Thank you for upgrading!
          </p>
          
          {loading ? (
            <p className="loading-text">Activating your premium features...</p>
          ) : error ? (
            <div className="result-error">
              <p>{error}</p>
            </div>
          ) : (
            <div className="result-features">
              <h3>You now have access to:</h3>
              <ul>
                <li>✓ Save unlimited documents</li>
                <li>✓ Access your document history</li>
                <li>✓ Ad-free experience</li>
                <li>✓ E-signature capabilities</li>
                <li>✓ Priority support</li>
              </ul>
            </div>
          )}
          
          <div className="result-actions">
            <Link to="/dashboard" className="btn btn-primary btn-lg">
              Go to Dashboard
            </Link>
            <Link to="/bill-of-sale" className="btn btn-secondary btn-lg">
              Create a Document
            </Link>
          </div>
          
          {sessionId && (
            <p className="session-info">
              Confirmation ID: {sessionId.substring(0, 20)}...
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
